import './AccountInfinityLimit.scss';
import { ReactElement } from 'react';

export const AccountInfinityLimit = (): ReactElement => <span className='account-infinity-limit'>&infin;</span>;
